import { Injectable } from '@angular/core';

@Injectable()
export class ArrayManipulationService {

  constructor() { }

  public GenerateIdProperty(array: any[]): any[] {
    return array.map((obj, index) => {
      return { ...obj, ID: index + 1 };
    });
  }

  public chunkArray<T>(array: T[], chunkSize: number): T[][] {
    const chunks: T[][] = [];

    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }

    return chunks;
  }
}
